export class ClienteEspecificaciones {  
    public tipinv: number;
    public codesp: number;
    public descri: string;
    public vreal: Number;
    public vstrg: string;
    public vdate: string;
    public vtime: string;
    public vchar: string;
    public ventero: number;

    public fcreac: string;
    public factua: string;
    public usuari: string;
    public activo: boolean;
    public swreque: boolean;
}
